export const parseGrade = (grade: number) => {
    let parsedGrade = grade.toFixed(1)
    parsedGrade = parsedGrade.replace(".", ",")
    return `${parsedGrade}`
}